import { Skeleton } from "antd";
import React from "react";

function JdDetailsCard({ jdDetails, skeletonLoading }) {
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };
  return (
    <>
      {skeletonLoading ? (
        <Skeleton.Button active block style={{ height: 126, width: "full" }} />
      ) : (
        <div className="bg-[#0F1B23] px-5 py-4 rounded-lg text-[#FCFCFD]">
          <p className="text-xl font-semibold">{jdDetails?.title}</p>
          <p className="text-[#EDC043] font-semibold mt-2">
            {jdDetails?.companyName}
          </p>
          <div className="flex items-center flex-wrap gap-x-4 gap-y-2 justify-between mt-3">
            <div className="flex items-center flex-wrap gap-x-5 gap-y-2">
              <span className="flex items-center gap-x-1">
                <span>
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.9987 10.416C9.37941 10.416 10.4987 9.29673 10.4987 7.91602C10.4987 6.5353 9.37941 5.41602 7.9987 5.41602C6.61799 5.41602 5.4987 6.5353 5.4987 7.91602C5.4987 9.29673 6.61799 10.416 7.9987 10.416Z"
                      stroke="#667085"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.9987 18.3327C9.66536 14.9993 14.6654 12.8479 14.6654 8.33268C14.6654 4.65078 11.6806 1.66602 7.9987 1.66602C4.3168 1.66602 1.33203 4.65078 1.33203 8.33268C1.33203 12.8479 6.33203 14.9993 7.9987 18.3327Z"
                      stroke="#667085"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span>{jdDetails?.jobLocation}</span>
              </span>
              <span className="flex items-center gap-x-1">
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3346 4.83333C13.3346 4.05836 13.3346 3.67087 13.2494 3.35295C13.0183 2.49022 12.3444 1.81635 11.4817 1.58519C11.1638 1.5 10.7763 1.5 10.0013 1.5C9.22633 1.5 8.83884 1.5 8.52092 1.58519C7.65819 1.81635 6.98432 2.49022 6.75315 3.35295C6.66797 3.67087 6.66797 4.05836 6.66797 4.83333M4.33464 16.5H15.668C16.6014 16.5 17.0681 16.5 17.4246 16.3183C17.7382 16.1586 17.9932 15.9036 18.153 15.59C18.3346 15.2335 18.3346 14.7668 18.3346 13.8333V7.5C18.3346 6.56658 18.3346 6.09987 18.153 5.74335C17.9932 5.42975 17.7382 5.17478 17.4246 5.01499C17.0681 4.83333 16.6014 4.83333 15.668 4.83333H4.33464C3.40121 4.83333 2.9345 4.83333 2.57798 5.01499C2.26438 5.17478 2.00941 5.42975 1.84962 5.74335C1.66797 6.09987 1.66797 6.56658 1.66797 7.5V13.8333C1.66797 14.7668 1.66797 15.2335 1.84962 15.59C2.00941 15.9036 2.26438 16.1586 2.57798 16.3183C2.9345 16.5 3.40121 16.5 4.33464 16.5Z"
                    stroke="#667085"
                    stroke-width="1.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Experience: {jdDetails?.yearsOfExperience}+ years</span>
              </span>
              <span className="flex items-center gap-x-1">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0013 4.99935V9.99935L13.3346 11.666M18.3346 9.99935C18.3346 14.6017 14.6037 18.3327 10.0013 18.3327C5.39893 18.3327 1.66797 14.6017 1.66797 9.99935C1.66797 5.39698 5.39893 1.66602 10.0013 1.66602C14.6037 1.66602 18.3346 5.39698 18.3346 9.99935Z"
                    stroke="#667085"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Created on {formatDate(jdDetails?.creationTime)}</span>
              </span>
            </div>
            <div
              onClick={() => window.open(jdDetails?.jdUrl, "_blank")}
              className="text-[#EDC043] hover:brightness-110 flex items-center gap-x-2 cursor-pointer"
            >
              <span>View JD</span>
              <span>
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.832031 9.16732L9.16536 0.833984M9.16536 0.833984H0.832031M9.16536 0.833984V9.16732"
                    stroke="#EDC043"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default JdDetailsCard;
